import type { IconSvgObject } from './types';

const ObtuseIcon: IconSvgObject = [
  ["path", { d: "M3 4.5L8.94721 16.3944C9.286 17.072 9.97852 17.5 10.7361 17.5H22M3 4.5L2 7.5M3 4.5L6 5.5M22 17.5L19.5 15.5M22 17.5L19.5 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.9994 17.5C14.9994 14.1863 12.3131 11.5 8.99937 11.5C8.14538 11.5 7.33306 11.6784 6.59766 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ObtuseIcon;
